import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function MFFooter() {
  const services = [
    { name: "Digital Marketing", slug: "digital-marketing-service" },
    { name: "Web Development", slug: "web-development-service" },
    { name: "Mobile App Development", slug: "mobile-app-development-service" },
    { name: "AI Development", slug: "ai-development-service" },
    { name: "IT Consulting", slug: "it-consulting-service" },
    { name: "E-Commerce Development", slug: "ecommerce-development-service" },
  ];

  const quickLinks = [
    { name: "Home", path: "" },
    { name: "About Us", path: "about" },
    { name: "Services", path: "services" },
    { name: "Portfolio", path: "portfolio" },
    { name: "Blog", path: "blog" },
    { name: "Contact", path: "contact" },
  ];

  return (
    <footer className="bg-dark text-light pt-5 pb-4">
      <div className="container">
        <div className="row g-4">
          {/* Company Info */}
          <div className="col-md-6 col-lg-4">
            <img
              src="/assets/img/logo/Meta_fox.png"
              style={{ maxWidth: "180px" }}
              alt="logo"
              className="img-fluid mb-3"
            />
            <p className="text-muted-new">
              We're a premium software company delivering cutting-edge digital
              solutions that transform businesses and drive growth through
              innovation.
            </p>
            <div className="d-flex gap-2 mt-3">
              <Link
                to="https://x.com/Meta_Fox_"
                target="_blank"
                className="btn btn-outline-light btn-sm rounded-2 p-2"
              >
                <Twitter size={16} />
              </Link>
              <Link
                to="https://in.linkedin.com/company/meta-fox"
                target="_blank"
                className="btn btn-outline-light btn-sm rounded-2 p-2"
              >
                <Linkedin size={16} />
              </Link>
              <Link
                to="https://www.instagram.com/metafox__/"
                className="btn btn-outline-light btn-sm rounded-2 p-2"
                target="_blank"
              >
                <Instagram size={16} />
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-md-6 col-lg-2">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={`/${link.path}`}
                    className="text-muted-new text-decoration-none d-block py-1"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-md-6 col-lg-3">
            <h5>Our Services</h5>
            <ul className="list-unstyled">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/${service.slug}`}
                    className="text-muted-new text-decoration-none d-block py-1"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-6 col-lg-3">
            <h5>Contact Info</h5>
            <div className="text-muted-new small">
              <div className="d-flex mb-2">
                <MapPin size={16} className="text-primary me-2 mt-1" />
                <div>
                  <div>Vadodara, Gujarat, India</div>
                </div>
              </div>
              <div className="d-flex mb-2">
                <Phone size={16} className="text-primary me-2 mt-1" />
                <Link
                  to={"tel:+91-6352118120"}
                  className="text-muted-new text-decoration-none"
                >
                  +91-6352118120
                </Link>
              </div>
              <div className="d-flex">
                <Mail size={16} className="text-primary me-2 mt-1" />
                <Link
                  to={"mailto:info@metafoxtech.com"}
                  className="text-muted-new text-decoration-none"
                >
                  info@metafoxtech.com
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-top border-secondary mt-5 pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="text-muted-new mb-2 mb-md-0 small">
            © 2025 MetaFox Tech. All rights reserved.
          </p>
          <div className="d-flex gap-3">
            <a href="#" className="text-muted-new text-decoration-none small">
              Privacy Policy
            </a>
            <a href="#" className="text-muted-new text-decoration-none small">
              Terms of Service
            </a>
            <a href="#" className="text-muted-new text-decoration-none small">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
